// extracted by mini-css-extract-plugin
export default {"menuBlock":"kF-z","title":"lF-z","nav":"mF-z","flexCell":"nF-z","facetLink":"oF-z"};